export default "__VITE_ASSET__B28Y8dLC__"